import { useCurrentRefinements } from "react-instantsearch-core";
import { useLocation } from "@grandvisionhq/frk-routing";
import { useIntl } from "@grandvisionhq/state";
import { useAlgoliaConfig } from "../../Algolia/Algolia/AlgoliaConfig.js";
const useFacets = () => {
  const { getLabel } = useIntl();
  const { facets } = useAlgoliaConfig();
  const { pathname } = useLocation();
  const isProductCategoryPage = !pathname.startsWith("/search");
  const excludedAttributes = isProductCategoryPage ? ["filterableAttributes.productType"] : [];
  const { items } = useCurrentRefinements({ excludedAttributes });
  const appliedFacets = items.reduce((acc, item) => {
    const facet = facets.find((facet2) => facet2.attribute === item.attribute);
    if (facet) {
      const label = facet.labelKey ? getLabel(facet.labelKey) : facet?.id || "";
      const facetKey = facet.id || "";
      return {
        ...acc,
        [facetKey]: {
          label,
          value: item.refinements.map((refinement) => refinement.value.toString())
        }
      };
    } else {
      return acc;
    }
  }, {});
  const numberOfAppliedFacets = Object.values(appliedFacets).flatMap(
    (facet) => facet.value
  ).length;
  return {
    appliedFacets,
    numberOfAppliedFacets
  };
};
export {
  useFacets
};
//# sourceMappingURL=use-facets.js.map
